import React from 'react';

/*
  Centralized status → color mapping (Design Tokens), replacing the
  per-module ad-hoc badge colors flagged in the UX review (section 5-A):
  green = completed/active, amber = awaiting approval, blue = in progress,
  red = rejected/fault, gray = anything else (draft/unknown).
*/
const STATUS_GROUPS = {
  success: ['OPERATING', 'ACTIVE', 'APPR', 'APPROVED', 'COMP', 'COMPLETE', 'COMPLETED', 'CLOSE', 'CLOSED', 'RESOLVED', 'INVOICED'],
  warning: ['WAPPR', 'WSCH', 'PENDING', 'DRAFT', 'NEW', 'ESCALATED', 'WPCOND', 'WMATL', 'WMAT'],
  info: ['INPRG', 'INPROG', 'IN_PROGRESS'],
  danger: ['CAN', 'CANC', 'CANCEL', 'CANCELLED', 'REJECT', 'REJECTED', 'EXPIRED', 'FAULT', 'DOWN'],
};

const VARIANT_STYLE = {
  success: { color: 'var(--status-success)', bg: 'var(--status-success-bg)' },
  warning: { color: 'var(--status-warning)', bg: 'var(--status-warning-bg)' },
  info: { color: 'var(--status-info)', bg: 'var(--status-info-bg)' },
  danger: { color: 'var(--status-danger)', bg: 'var(--status-danger-bg)' },
  neutral: { color: 'var(--status-neutral)', bg: 'var(--status-neutral-bg)' },
};

export const getStatusVariant = (status) => {
  const key = String(status || '').toUpperCase().trim();
  for (const [variant, codes] of Object.entries(STATUS_GROUPS)) {
    if (codes.includes(key)) return variant;
  }
  return 'neutral';
};

const StatusBadge = ({ status, label, className = '' }) => {
  const variant = getStatusVariant(status);
  const style = VARIANT_STYLE[variant];

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-sm text-[9px] font-black uppercase shadow-sm ring-1 ring-inset ${className}`}
      style={{ color: style.color, backgroundColor: style.bg, '--tw-ring-color': `${style.color}33` }}
    >
      {label || status}
    </span>
  );
};

export default StatusBadge;
